const getCssVar = (variable: string) =>
  getComputedStyle(window.document.documentElement).getPropertyValue(variable);

export default getCssVar;
